export default {
  // Navigation Links
  home: 'Home',
  features: 'Features',
  about: 'About',
  contact: 'Contact',
  blog: 'Blog',
  dashboard: 'Dashboard',
  settings: 'Settings',
  login: 'Login',
  signup: 'Sign Up',
  logout: 'Logout',
  supportUs: 'Support Us',
  
  // Logout related text
  loggingOut: 'Logging out...',
  redirectingToLogin: 'Redirecting to login...'
};